import ApiCore from '@/api/index';
import globalDomains from '@/utils/global-domains';

const BjApi = ApiCore(globalDomains.BJAPI_AFREECATV);
export default BjApi;
